import type { KadeweUser } from "~/types";

export default defineNuxtRouteMiddleware((to) => {
    const user = useSanctumUser<KadeweUser>();
    const localePath = useLocalePath();

    if (user.value?.student.has_to_verify && !to.path.startsWith(localePath("/register/student"))) {
        console.warn("Student verified: User has to verify their student id", to.path);
        return navigateTo(localePath("/register/student/select"));
    }
});
